/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Capacity_StandingInputs */

const en_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standing Capacity`)
};

const es_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad de pie`)
};

const fr_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité debout`)
};

const de_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stehplatzkapazität`)
};

const ja_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立食での収容人数`)
};

const zh_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`站立容量`)
};

const ar_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعة (وقوفاً)`)
};

const id_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas Berdiri`)
};

const it_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capienza in Piedi`)
};

const ru_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вместимость (стоя)`)
};

const pt_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade em Pé`)
};

const ko_field_capacity_standing = /** @type {(inputs: Field_Capacity_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탠딩 수용 인원`)
};

/**
* | output |
* | --- |
* | "Standing Capacity" |
*
* @param {Field_Capacity_StandingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_capacity_standing = /** @type {((inputs?: Field_Capacity_StandingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Capacity_StandingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_capacity_standing(inputs)
	if (locale === "es") return es_field_capacity_standing(inputs)
	if (locale === "fr") return fr_field_capacity_standing(inputs)
	if (locale === "de") return de_field_capacity_standing(inputs)
	if (locale === "ja") return ja_field_capacity_standing(inputs)
	if (locale === "zh") return zh_field_capacity_standing(inputs)
	if (locale === "ar") return ar_field_capacity_standing(inputs)
	if (locale === "id") return id_field_capacity_standing(inputs)
	if (locale === "it") return it_field_capacity_standing(inputs)
	if (locale === "ru") return ru_field_capacity_standing(inputs)
	if (locale === "pt") return pt_field_capacity_standing(inputs)
	return ko_field_capacity_standing(inputs)
});